import React, { useState, useEffect } from "react";
import { Menu, User, LogOutIcon } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import {  useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

export default function Header({ user, toggleSidebar, unpaidInvoices }) {
    const navigate = useNavigate();
  
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentUrlName, setCurrentUrlName] = useState("Dashboard");
  const location = useLocation();

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  // Function to match URL with custom name
  const matchUrlWithName = (url) => {
    switch (url) {
      case '':
        return 'Dashboard';
      case 'dashboard':
        return 'Dashboard';
      case 'property':
        return 'Properties';
      case 'bulk':
        return 'Bulk Uploads';
      case 'historical import':
        return 'Historical Import';
      case 'utilities':
        return 'Utilities';
      case 'reports':
        return 'Reports';
      case 'repairs':
        return 'Repairs';
      case 'messages':
        return 'Communicate';
      case 'profile':
        return 'Profile';
      case 'subscription':
        return 'Subscription';
      case 'selected-property':
        return 'Property Selected';
      default:
        // Split the URL by slashes and retrieve the first two words
        const words = url.split('/').filter((word) => word !== '');

        if (words.length >= 2) {
          // Remove hyphens and digits from the words
          const filteredWords = words
            .map((word) => word.replace(/[-0-9]/g, ' '))
            .filter((word) => word !== '');

          return filteredWords.join(' ');
        } else {
          return url;
        }
    }
  };

  // Function to clean and transform URL
  const cleanUrl = (url) => {
    // Remove everything after '?' if it exists
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    // Remove leading slash
    const trimmedUrl = baseUrl.startsWith('/') ? baseUrl.substring(1) : baseUrl;
    // Replace hyphens with spaces
    return trimmedUrl.replaceAll('-', ' ');
  };

  useEffect(() => {
    // Get the current path without the leading slash
    const path = location.pathname.substring(1);
    const cleanedUrl = cleanUrl(path);
    const matchedName = matchUrlWithName(cleanedUrl);
    setCurrentUrlName(matchedName);
  }, [location]);

  const goBack = () => {
    window.history.back();
  };

    const handleLogout = () => {
    localStorage.removeItem("authTokens");
    navigate("/login");
  };


  const hideBackArrow = location.pathname === '/utilities' || 
                       location.pathname === '/properties' || 
                       location.pathname === '/subscription' || 
                       location.pathname === '/wallet' || 
                       location.pathname === '/expense' || 
                       location.pathname === '/messages' || 
                       location.pathname === '/bulk' || 
                       location.pathname === '/historical-import' || 
                       location.pathname === '/property-settings' || 
                       location.pathname === '/payment-approvals' || 
                       location.pathname === '/reports' || 
                       location.pathname === '/repairs' || 
                       location.pathname === '/profile' || 
                       location.pathname === '/dashboard' || 
                       location.pathname === '/';

  return (
    <header className="flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200 relative z-30">
      <div className="flex items-center space-x-3">
        {/* Sidebar toggle (mobile only) */}
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-md text-gray-600 hover:bg-gray-100 md:hidden"
        >
          <Menu size={20} />
        </button>

        {/* Optional back arrow */}
        {!hideBackArrow && (
          <button onClick={goBack} className="text-blue-600 hover:text-blue-700">
            <i className="bi bi-arrow-left-circle-fill text-2xl" />
          </button>
        )}

        {/* Page title */}
        <h1 className="text-lg sm:text-xl text-gray-800 mt-3 uppercase">
          {currentUrlName}
        </h1>
      </div>

      <div className="flex items-center space-x-4">
        {/* Unpaid Invoice Button */}
        {unpaidInvoices > 0 && (
          <Link to="/unpaid-invoice">
            <button type="button" className="btn btn-primary position-relative" style={{ height: "fit-content", alignSelf: "center" }}>
              Unpaid Invoices
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {unpaidInvoices}
              </span>
            </button>
          </Link>
        )}

        {/* User Profile Image */}
        <div className="w-10 h-10 rounded-full overflow-hidden border border-gray-300">
          <img
            src={user?.image || "/media/neutral.png"}
            alt="User"
            className="w-full h-full object-cover"
          />
        </div>

        {/* User Name + Dropdown */}
        <div className="relative">
          <button
            onClick={toggleDropdown}
            className="text-lg font-medium text-gray-800 focus:outline-none"
          >
            {user?.full_name}
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-md z-10">
              <Link
                to="/profile"
                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-decoration-none"
              >
                <User size={16} className="mr-2" />
                Profile
              </Link>
              <Button
                // to="/logout"
                onCClick={handleLogout}
                className="flex items-center bg-transparent w-100 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-decoration-none"
              >
                <LogOutIcon size={16} className="mr-2" />
                Logout
              </Button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
